import React, { KeyboardEvent, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'

import * as types from '../../redux/constantes/job'
import { ListJobsAction } from '../../redux/actions/job'

import { ContainerContentListInfo, ContainerTemplate } from '../../components/Containers'
import { FiltersSearch } from '../../components/FiltersSearch'
import { MessageBoxError } from '../../components/MessageBox'
import { InputText } from '../../components/InputText'
import { ButtonSend } from '../../components/ButtonSend'
import { Header } from '../../components/Header'
import { accessKeyIsValid } from '../../helpers/accessKeyIsValid'
import { SET_KEY } from '../../redux/constantes/infoPages'
import { initialStateProps } from '../../redux/reducer/infosPage'
import { ButtonRedirect } from '../../components/ButtonRedirect'
import { WrapperButtonsModal } from '../../components/Modal/style'
import { jobs } from '../../types/components/jobs'
import { Table } from '../../components/Table'
import { TableItem } from '../../components/TableItem'
import { WrapperMobile } from '../../components/Wrapper'
import { Card } from '../../components/Card'

export const TemplateListJobsAdmin: React.FC = () => {
  const [area, setArea] = useState<string>()
  const [place, setPlace] = useState<string>()
  const [office, setOffice] = useState<string>()
  const [modality, setModality] = useState<string>()

  const { listJobs, loading, error } = useSelector((state: RootStateOrAny) => state.listJobs)
  const state: initialStateProps = useSelector((state: RootStateOrAny) => state.infoPages)
  const dispatch = useDispatch()

  const [isValid, setIsValid] = useState(false)
  const [validateAccessKey, setValidateAccessKey] = useState(true)

  const onSubmit = () => {
    if (state !== undefined) {
      if (state.key === process.env.REACT_APP_KEY) {
        setIsValid(true)
        dispatch(ListJobsAction())
      } else {
        setIsValid(false)
      }
    }
  }

  const logout = () => {
    dispatch({ type: SET_KEY, payload: '' })
    setIsValid(false)
  }

  const handleKeyUp = (e: KeyboardEvent) => {
    if (state !== undefined) {
      if (e.code === 'Enter' && state.key !== '') {
        onSubmit()
      }
    }
  }

  useEffect(() => {
    onSubmit()
  }, [])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.LIST_JOBS_ERROR })
      }, 5000)
    }
  }, [error])

  const filteredJobsByArea = area
    ? listJobs &&
      listJobs.jobs.filter((job: jobs) => {
        return job.Area.toLowerCase().includes(area.toLowerCase())
      })
    : listJobs && listJobs.jobs

  const filteredJobsByPlace = place
    ? filteredJobsByArea &&
      filteredJobsByArea.filter((job: jobs) => {
        return job.Local.toLowerCase().includes(place.toLowerCase())
      })
    : filteredJobsByArea && filteredJobsByArea

  const filteredJobsByOffice = office
    ? filteredJobsByPlace &&
      filteredJobsByPlace.filter((job: jobs) => {
        return job.Cargo.toLowerCase().includes(office.toLowerCase())
      })
    : filteredJobsByPlace && filteredJobsByPlace

  const filteredJobsByModality = modality
    ? filteredJobsByOffice &&
      filteredJobsByOffice.filter((job: jobs) => {
        return job.Modalidade.toLowerCase().includes(modality.toLowerCase())
      })
    : filteredJobsByOffice && filteredJobsByOffice

  return (
    <ContainerTemplate>
      <Header text="Gestão de Vagas" />
      <ContainerContentListInfo>
        {!isValid && (
          <InputText
            label={`Chave de Acesso ${!validateAccessKey ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
            onBlur={() => accessKeyIsValid(state && state.key, setValidateAccessKey)}
            onChange={e => dispatch({ type: SET_KEY, payload: e.target.value })}
            placeholder=""
            value={state && state.key}
            isValidate={validateAccessKey}
            handleKeyUp={handleKeyUp}
          />
        )}
        {!loading ? (
          !isValid && (
            <ButtonSend color="normal" nameButton="Acessar" disabled={!validateAccessKey} onClick={onSubmit} />
          )
        ) : (
          <ButtonSend color="alert" nameButton="Aguarde..." disabled={true} />
        )}
      </ContainerContentListInfo>
      {isValid && (
        <ContainerContentListInfo>
          {error && <MessageBoxError>{error}</MessageBoxError>}
          <WrapperButtonsModal>
            <ButtonRedirect link="/admin/nova-vaga" nameButton="Nova Vaga" />
            <ButtonSend color="error" nameButton="Sair" onClick={logout} />
          </WrapperButtonsModal>
          <FiltersSearch
            jobsArray={listJobs && listJobs.jobs}
            area={area}
            setArea={setArea}
            place={place}
            setPlace={setPlace}
            office={office}
            setOffice={setOffice}
            modality={modality}
            setModality={setModality}
          />
          <Table>
            {filteredJobsByModality &&
              filteredJobsByModality
                .sort(function (a: jobs, b: jobs) {
                  if (a.Cargo < b.Cargo) {
                    return -1
                  } else {
                    return true
                  }
                })
                .map((job: jobs, index: number) => (
                  <TableItem job={job} key={index} nameButton="Editar" pathButton="/admin/editar-vaga" />
                ))}
          </Table>
          <WrapperMobile>
            {filteredJobsByModality &&
              filteredJobsByModality
                .sort(function (a: jobs, b: jobs) {
                  if (a.Cargo < b.Cargo) {
                    return -1
                  } else {
                    return true
                  }
                })
                .map((job: jobs, index: number) => (
                  <Card job={job} key={index} nameButton="Editar" pathButton="/admin/editar-vaga" />
                ))}
          </WrapperMobile>
        </ContainerContentListInfo>
      )}
    </ContainerTemplate>
  )
}
